import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/FindIdResultPC.css';

function FindIdResultPC() {
  const location = useLocation();
  const navigate = useNavigate();
  const foundId = location.state?.foundId;

  const handleFindPassword = () => {
    navigate('/find-account');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <div className="pc-page-container">
      <div className="pc-content-wrapper">
        
        
        {/* Main Content */}
        <main className="pc-main-content">
          <div className="pc-content-container">
            {/* Title Section */}
            <div style={{
              marginBottom: '50px',
              display: 'flex',
              alignItems: 'center',
              gap: '15px'
            }}>
              <div style={{
                width: '4px',
                height: '30px',
                backgroundColor: '#2fb5a8',
                borderRadius: '2px'
              }}></div>
              <h1 style={{
                fontSize: '28px',
                fontWeight: '600',
                color: '#222222',
                margin: 0
              }}>아이디/비밀번호 찾기</h1>
            </div>

            {/* Result Box */}
            <div style={{
              maxWidth: '600px',
              margin: '0 auto',
              backgroundColor: '#ffffff',
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              padding: '60px 40px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              textAlign: 'center'
            }}>
              <div style={{
                marginBottom: '40px'
              }}>
                <p style={{
                  fontSize: '18px',
                  color: '#333333',
                  margin: '0 0 10px 0',
                  lineHeight: '1.5'
                }}>
                  회원님께서 가입하신 ID는
                </p>
                <p style={{
                  fontSize: '24px',
                  fontWeight: '600',
                  color: '#2fb5a8',
                  margin: '0',
                  lineHeight: '1.5'
                }}>
                  {foundId} 입니다.
                </p>
              </div>

              {/* Action Buttons */}
              <div style={{
                display: 'flex',
                gap: '15px',
                justifyContent: 'center'
              }}>
                <button
                  onClick={handleFindPassword}
                  style={{
                    padding: '12px 30px',
                    backgroundColor: '#666666',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                >
                  비밀번호 찾기
                </button>
                <button
                  onClick={handleLogin}
                  style={{
                    padding: '12px 30px',
                    backgroundColor: '#2fb5a8',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                >
                  로그인
                </button>
              </div>
            </div>
          </div>
        </main>

        
      </div>
    </div>
  );
}

export default FindIdResultPC; 